<template>
  <div id="Software">
    <div class="flex">
      <img src="@/assets/images/pic200-9.jpeg" style="width: 18%; margin-right: 2%; height: auto" alt="" />
      <img src="@/assets/images/pic200-10.svg" style="width: 80%; height: auto" alt="" />
    </div>
    <div class="flex">
      <div class="text">
        该系统面向旅游管理和面向旅游服务两大方向，涉及到旅游管理人员和游客两大群体。旅游管理端为全域旅游数据采集和数据分析两大系统，采集乡镇旅游、乡村旅游、乡镇教育、工业旅游、健康旅游、文化旅游、交通旅游等行业的旅游资源信息，为其它系统提供数据支撑。为旅游决策者提供多维度的旅游行业数据统计，主要有城市接待、交通接待、产品营销、民宿过夜、关注分析、热门线路、产品分析等几大主题分析。旅游服务端提供公共服务系统(小程序)，为游客提供全面的旅游资讯服务，从游前、游中至游后提供旅游
        一站式服务体验，包括全域攻略、自驾车/自行车线路、定制旅游、评价/投诉等功能。 </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Software",
  data() {
    return {};
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
}

.text {
  line-height: 24px;
  font-weight: 500;
  color: #666;
  margin-top: 40px;
  text-indent: 28px
}
</style>




// WEBPACK FOOTER //
// src/view/Solution11.vue